// Theme configuration for the entire application
export const themes = {
  classic: {
    name: 'Classic Art',
    bg: 'bg-[#fcfcfc]', 
    text: 'text-gray-900',
    textMuted: 'text-gray-500',
    accent: 'bg-black',
    accentText: 'text-white',
    border: 'border-gray-200',
    hoverBorder: 'from-gray-200 via-gray-400 to-gray-200',
    button: 'bg-white/30 backdrop-blur-md text-gray-800 shadow-sm border border-gray-100/50', 
    navFont: 'font-serif',
    heroOverlay: 'bg-black/20',
    iconColor: '#333'
  },
  nature: {
    name: 'Nature Retreat',
    bg: 'bg-[#F5F5F0]', 
    text: 'text-[#2C3E32]', 
    textMuted: 'text-[#6B7F6F]',
    accent: 'bg-[#4A5D4E]',
    accentText: 'text-[#F5F5F0]',
    border: 'border-[#D8D8D0]',
    hoverBorder: 'from-[#4A5D4E] via-[#8DA399] to-[#4A5D4E]',
    button: 'bg-[#E8E8E0]/50 backdrop-blur-md text-[#2C3E32] shadow-sm',
    navFont: 'font-sans',
    heroOverlay: 'bg-[#2C3E32]/20',
    iconColor: '#4A5D4E'
  },
  luxury: {
    name: 'Midnight Gold',
    bg: 'bg-[#1A1A1A]',
    text: 'text-[#E5E5E5]',
    textMuted: 'text-[#999999]',
    accent: 'bg-[#C5A059]', 
    accentText: 'text-black',
    border: 'border-[#333333]',
    hoverBorder: 'from-[#C5A059] via-[#F2D088] to-[#C5A059]',
    button: 'bg-[#262626]/50 backdrop-blur-md text-[#C5A059] border border-[#333] shadow-sm',
    navFont: 'font-serif',
    heroOverlay: 'bg-black/50',
    iconColor: '#C5A059'
  }
};
